import React from 'react'
//@ts-ignore
import s from './ColumnViewParam.module.scss'

export type inputComponentsAdditionalProperties = {
    maxWidth?: string;
    fontWidth?: number;
}
export type ColumnViewParamT = {
    label: string,
    id: string,
    isRequired: boolean,
    additionalProperties?: inputComponentsAdditionalProperties
    hint?: any
    children?: any,
}

export const ColumnViewParam = ({ ...props }: ColumnViewParamT) => {
    let { children, label, isRequired, additionalProperties } = props;

   
    const styleTitle: any = {
        fontWidth: (!!additionalProperties && additionalProperties['fontWidth']) ? `${additionalProperties['fontWidth']}` : '400'

    };
    const style = {
        maxWidth: !!additionalProperties ? additionalProperties['maxWidth'] : `auto`,
        width: !!additionalProperties ? `100%` : `auto`,
    };
    return (
        <div className={s.lineParams}>
            <div className={s.lineParamsTitle} style={styleTitle}>{label} {isRequired && (<span>*</span>)}</div>
            <div className={s.lineParamsComponent} style={style}>{children}</div>
        </div>
    )
}
